import { Link } from "react-router-dom"

export default function ContactPage(){
    return(
        <section className="dark:bg-gray-800 dark:text-gray-100">
	<div className="container flex flex-col justify-center p-6 mx-auto sm:py-12 lg:py-24 lg:flex-row lg:justify-between">
		<div className="flex flex-col justify-center p-6 text-center rounded-sm lg:max-w-md xl:max-w-lg lg:text-left">
			<h1 className="text-5xl font-bold leading-none sm:text-6xl">Question? 
				<span className="dark:text-primary-400"> Comment? </span>
                Want to be<span className="dark:text-primary-400"> Envolved?</span>
			</h1>
			<p className="mt-6 mb-8 text-lg sm:mb-12">Contact us with the link below!
				<br></br> 
			</p>
			<div className="flex flex-col space-y-4 sm:items-center sm:justify-center sm:flex-row sm:space-y-0 sm:space-x-4 lg:justify-start">
				<a rel="noopener noreferrer" href="mailto:contact@envolvly" className="px-8 py-3 text-lg font-semibold rounded dark:bg-primary-400 dark:text-gray-900">Email</a>
				<Link to="/" className="px-8 py-3 text-lg font-semibold border rounded dark:border-gray-100">Surprise!</Link>
			</div>
		</div>
		<div className="flex items-center justify-center p-6 mt-8 lg:mt-0 h-72 sm:h-80 lg:h-96 xl:h-112 2xl:h-128">
			<img src="https://mambaui.com/assets/svg/Business_SVG.svg" alt="" className="object-contain h-72 sm:h-80 lg:h-96 xl:h-112 2xl:h-128" />
		</div>
	</div>
</section>
    )
}